import { mediaData } from '@/mocks/homeData';

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精彩视频
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            深度解读娱乐圈热门事件，视频呈现更直观
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-white text-xs">
                  {item.duration}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-950 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}